import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { filterStateSelector, searchSelector } from '../store/selectors';
import { fromDateStr, toDateStr } from '../../../helpers/utcDate';
import useDebouncedFunc from '../../../hooks/useDebounsedFunc';

const delay = 1000;

const getParams = (state) => {
  const {
    period: [from, to],
    ...restState
  } = state;

  const fromDate = fromDateStr(from);
  const toDate = toDateStr(to);

  return {
    fromDate,
    toDate,
    ...restState,
  };
};

const useFilterForQuery = () => {
  const filterState = useSelector(filterStateSelector);
  const search = useSelector(searchSelector);

  const [params, setParams] = useState(
    search.trim() ? { search: search.trim() } : getParams(filterState)
  );
  const debouncedSetParams = useDebouncedFunc(setParams, delay);

  useEffect(() => {
    if (search) {
      setParams({ search: search.trim() });
    } else {
      const newParams = getParams(filterState);
      debouncedSetParams(newParams);
    }
  }, [JSON.stringify(filterState), search]);

  return params;
};

export default useFilterForQuery;
